import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { AIModuleProvider } from './contexts/AIModuleContext';
import { aiStore } from './store';

// AI Module Pages
import AIDashboard from './pages/AIDashboard';
import AIAssistants from './pages/AIAssistants';
import AIAssistantBuilder from './pages/AIAssistantBuilder';
import AIConversations from './pages/AIConversations';
import AIConversationView from './pages/AIConversationView';
import AIFlowBuilder from './pages/AIFlowBuilder';
import AIKnowledgeBase from './pages/AIKnowledgeBase';
import AICalendar from './pages/AICalendar';
import AIBilling from './pages/AIBilling';
import AIAnalytics from './pages/AIAnalytics';
import AISettings from './pages/AISettings';

interface LoopletAIModuleProps {
  isEnabled?: boolean;
  theme?: 'light' | 'dark';
  basePath?: string;
}

const LoopletAIModule: React.FC<LoopletAIModuleProps> = ({ 
  isEnabled = true, 
  theme = 'dark',
  basePath = '/ai'
}) => {
  if (!isEnabled) {
    return null;
  }

  return (
    <Provider store={aiStore}>
      <AIModuleProvider theme={theme}>
        <div className="looplet-ai-module" data-theme={theme}>
          <Routes>
            <Route path={`${basePath}/dashboard`} element={<AIDashboard />} />
            <Route path={`${basePath}/assistants`} element={<AIAssistants />} />
            <Route path={`${basePath}/assistants/:id/builder`} element={<AIAssistantBuilder />} />
            <Route path={`${basePath}/conversations`} element={<AIConversations />} />
            <Route path={`${basePath}/conversations/:id`} element={<AIConversationView />} />
            <Route path={`${basePath}/flows`} element={<AIFlowBuilder />} />
            <Route path={`${basePath}/knowledge`} element={<AIKnowledgeBase />} />
            <Route path={`${basePath}/calendar`} element={<AICalendar />} />
            <Route path={`${basePath}/billing`} element={<AIBilling />} />
            <Route path={`${basePath}/analytics`} element={<AIAnalytics />} />
            <Route path={`${basePath}/settings`} element={<AISettings />} />
          </Routes>
        </div>
      </AIModuleProvider>
    </Provider>
  );
};

export default LoopletAIModule;